import { combineReducers } from "redux-immutable";

import ContentStatStateSlice from "../../models/state/contentStats";
import { contentStatsMeta } from "./state/meta";
import { contentStats } from "./state/stats";

export default combineReducers(
  {
    meta: contentStatsMeta,
    stats: contentStats
  },
  () => new ContentStatStateSlice() as any
);
